import { useEffect, useMemo, useState } from 'react';
import {
  MaterialReactTable,
  useMaterialReactTable,
  type MRT_ColumnDef,
} from 'material-react-table';
import { Grid, IconButton, Tooltip, Typography } from '@mui/material';
import AddBoxIcon from '@mui/icons-material/AddBox';
import { ProductoForm, TreeNode } from '@/shared/interfaces';
import Cancel from '@mui/icons-material/Cancel';
import { gridSizeConst2, gridSizeMdLg6, } from '@/shared';
import { TabTextLabel } from '@/shared/components/ui';
import { UseFormReturn } from 'react-hook-form';
import Delete from '@mui/icons-material/Delete';
import CustomAutocompleteInventariable from './CustomAutocompleteInventariable';
import { useCatalogoPlanCuentaStore } from '@/store/erp/shared/catalogo-plan-cuenta.store';

interface PlanCuentaProductoComponenteProps {
  form: UseFormReturn<ProductoForm, any, ProductoForm>
}

const PlanCuentaProductoComponente = ({ form }: PlanCuentaProductoComponenteProps) => {

  const [isCreate, setIsCreate] = useState<boolean>(false);
  const [tableData, setTableData] = useState<TreeNode[]>([]);
  const { isLoadingCatalogoPlanCuenta: isLoadingPlanCuenta, catalogoPlanCuenta: cuentas } = useCatalogoPlanCuentaStore();

  useEffect(() => {

    if (isLoadingPlanCuenta) return;

    const arrayBSet = new Set(form.getValues().cuentas_contables);
    const filteredArray = cuentas.filter(item => arrayBSet.has(item.id));

    setTableData(filteredArray)

    return () => {

    }
  }, [])


  const columns = useMemo<MRT_ColumnDef<TreeNode>[]>(
    () => [
      {
        accessorKey: 'id', //access nested data with dot notation
        header: 'Numero Cuenta',
        size: 150
      },

      {
        accessorKey: 'name',
        header: 'Nombre de la cuenta',
        size: 500,
      },
    ],
    [],
  );

  const table = useMaterialReactTable({
    columns,
    data: tableData,

    muiTableBodyCellProps: {
      sx: {
        backgroundColor: 'white',
        //border: '1px solid #ccc',
        p: '2px 16px'
      }
    },
    muiTableBodyRowProps: {
      sx: {
        height: '12px'
      }
    },

    muiTableHeadCellProps: {
      sx: {
        borderBlock: '1px solid #ccc'
      }
    },
    positionToolbarAlertBanner: "top",
    renderTopToolbarCustomActions: () => (
      <Grid container spacing={3} display={'flex'} padding={'10px 0px'} justifyContent={'space-between'}>
        <Grid item {...gridSizeMdLg6} alignContent={'center'} alignItems={'center'} justifyItems={'center'}>
          <TabTextLabel text={'CATALAGO DE CUENTAS CONTABLES'} mt={0} pb={0} pl={0} pt={2} />

        </Grid>
        {!isCreate && (
          <Grid item {...gridSizeMdLg6} justifyContent={'end'} textAlign={'end'}>
            <Tooltip title="Agregar Cuenta Contable" placement='top'>
              <IconButton onClick={() => {
                setIsCreate(true)
              }} >
                <AddBoxIcon />
              </IconButton>
            </Tooltip>
          </Grid>
        )
        }

        {isCreate && (

          <Grid item container {...gridSizeMdLg6}
            justifyContent={'space-between'}
            textAlign={'end'}
            alignContent={'center'}
            alignItems={'center'}
            justifyItems={'center'}
          >

            <Grid item xs={10}>
              <CustomAutocompleteInventariable
                onClick={(e: TreeNode) => {

                  setTableData((prevData) => {
                    // Verificar si el nodo ya existe en la tabla
                    if (prevData.some((t) => t.id === e.id)) {
                      return prevData; // Si existe, no hacemos cambios
                    }

                    const updatedData = [...prevData, { id: e.id, name: e.name }];

                    // Actualizar el formulario con el nuevo estado
                    form.setValue("cuentas_contables", updatedData);

                    return updatedData; // Retornar el nuevo estado actualizado
                  });

                }}
              />
            </Grid>
            <Grid item {...gridSizeConst2}>
              <IconButton onClick={() => setIsCreate(false)}>
                <Cancel />
              </IconButton>
            </Grid>
          </Grid>
        )}

      </Grid>
    ),

    renderRowActions: ({ row }) => (
      <IconButton onClick={() => {
        const newData = tableData.filter(e => e.id != row.original.id);
        form.setValue('cuentas_contables', newData)

        setTableData(newData);
      }} >
        <Delete />
      </IconButton>
    ),

    renderEmptyRowsFallback: () => (
      <Typography textAlign={'center'}
        sx={{ fontStyle: 'italic', padding: '10px' }}
      >No hay registros para mostrar.</Typography>
    ),

    enableRowActions: true,
    positionActionsColumn: 'first',
    enableColumnFilters: false,
    enablePagination: false,
    enableSorting: false,
    enableFullScreenToggle: false,
    enableGlobalFilter: false,
    enableDensityToggle: false,
    enableHiding: false,
  });


  return <MaterialReactTable table={table} />;
};

export default PlanCuentaProductoComponente;
